import React, { useState } from "react";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
} from "reactstrap";

const TagContentModal = ({
  isTagContentModalOpen,
  tagModalToggle,
  modalHeader,
  label,
  textAreaValue,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
  
  if (typeof window === "undefined") return;

  // Modern browsers
  if (navigator?.clipboard?.writeText) {
    navigator.clipboard
      .writeText(textAreaValue)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(fallbackCopy);
  } else {
    fallbackCopy();
  }
};

const fallbackCopy = () => {
  try {
    const textArea = window.document.createElement("textarea");
    textArea.value = textAreaValue;
    window.document.body.appendChild(textArea);
    textArea.select();
    window.document.execCommand("copy");
    window.document.body.removeChild(textArea);
  
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);    
  } catch (error) {
    
  }
};


  return (
    <Modal
      isOpen={isTagContentModalOpen}
      toggle={tagModalToggle}
      centered
      size="lg"
    >
      <ModalHeader>{modalHeader}</ModalHeader>
      <ModalBody>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <Label className="mb-0">{label}</Label>
          <Button
            onClick={handleCopy}
            size="sm"
            className="btn-gradient-primary d-flex align-items-center"
          >
            {copied ? (
              <>
                <i className="fa fa-check mr-1" />
                Copied
              </>
            ) : (
              <>
                <i className="fa fa-clone mr-1" />
                Copy
              </>
            )}
          </Button>
        </div>
        <textarea
          className="ads-textarea"
          rows="5"
          disabled
          value={textAreaValue}
          style={{
            width: "100%",
            resize: "vertical",
            fontFamily: "monospace",
          }}
        />
      </ModalBody>
    </Modal>
  );
};

export default TagContentModal;
